export const BasicOptions = {
  initialInfo: [
    {
      id: 1,
      option: "Roof Photo",
      available: true,
    },
  ],
  wireDiagram: [
    {
      id: 1,
      option: "Liner measurements",
      available: false,
    },
    {
      id: 2,
      option: "Pitch by facet",
      available: false,
    },
    {
      id: 3,
      option: "Area by facet",
      available: false,
    },
  ],
  measurements: [
    {
      id: 1,
      option: "Total area",
      available: true,
    },
    {
      id: 2,
      option: "Squares",
      available: true,
    },
    {
      id: 3,
      option: "Hip",
      available: false,
    },
    {
      id: 4,
      option: "Ridge",
      available: false,
    },
    {
      id: 5,
      option: "Valley",
      available: false,
    },
    {
      id: 6,
      option: "Rake",
      available: false,
    },
    {
      id: 7,
      option: "Eave",
      available: false,
    },
    {
      id: 8,
      option: "Drip edge",
      available: false,
    },
    {
      id: 9,
      option: "Step Flashing",
      available: false,
    },
    {
      id: 10,
      option: "Head Flashing",
      available: false,
    },
    {
      id: 11,
      option: "Waste Calculation",
      available: false,
    },
  ],
};

export const StandardOptions = {
  initialInfo: [
    {
      id: 1,
      option: "Roof Photo",
      available: true,
    },
  ],
  wireDiagram: [
    {
      id: 1,
      option: "Liner measurements",
      available: true,
    },
    {
      id: 2,
      option: "Pitch by facet",
      available: true,
    },
    {
      id: 3,
      option: "Area by facet",
      available: false,
    },
  ],
  measurements: [
    {
      id: 1,
      option: "Total area",
      available: true,
    },
    {
      id: 2,
      option: "Squares",
      available: true,
    },
    {
      id: 3,
      option: "Hip",
      available: true,
    },
    {
      id: 4,
      option: "Ridge",
      available: true,
    },
    {
      id: 5,
      option: "Valley",
      available: true,
    },
    {
      id: 6,
      option: "Rake",
      available: true,
    },
    {
      id: 7,
      option: "Eave",
      available: true,
    },
    {
      id: 8,
      option: "Drip edge",
      available: false,
    },
    {
      id: 9,
      option: "Step Flashing",
      available: false,
    },
    {
      id: 10,
      option: "Head Flashing",
      available: false,
    },
    {
      id: 11,
      option: "Waste Calculation",
      available: false,
    },
  ],
};

export const ComprehensiveOptions = {
  initialInfo: [
    {
      id: 1,
      option: "Roof Photo",
      available: true,
    },
  ],
  wireDiagram: [
    {
      id: 1,
      option: "Liner measurements",
      available: true,
    },
    {
      id: 2,
      option: "Pitch by facet",
      available: true,
    },
    {
      id: 3,
      option: "Area by facet",
      available: true,
    },
  ],
  measurements: [
    {
      id: 1,
      option: "Total area",
      available: true,
    },
    {
      id: 2,
      option: "Squares",
      available: true,
    },
    {
      id: 3,
      option: "Hip",
      available: true,
    },
    {
      id: 4,
      option: "Ridge",
      available: true,
    },
    {
      id: 5,
      option: "Valley",
      available: true,
    },
    {
      id: 6,
      option: "Rake",
      available: true,
    },
    {
      id: 7,
      option: "Eave",
      available: true,
    },
    {
      id: 8,
      option: "Drip edge",
      available: true,
    },
    {
      id: 9,
      option: "Step Flashing",
      available: true,
    },
    {
      id: 10,
      option: "Head Flashing",
      available: true,
    },
    {
      id: 11,
      option: "Waste Calculation",
      available: true,
    },
  ],
};

export const ClaimsOptions = {
  initialInfo: [
    {
      id: 1,
      option: "Roof Photo",
      available: true,
    },
  ],
  wireDiagram: [
    {
      id: 1,
      option: "Liner measurements",
      available: false,
    },
    {
      id: 2,
      option: "Pitch by facet",
      available: false,
    },
    {
      id: 3,
      option: "Area by facet",
      available: false,
    },
  ],
  measurements: [
    {
      id: 1,
      option: "Total area",
      available: true,
    },
    {
      id: 2,
      option: "Squares",
      available: true,
    },
    {
      id: 3,
      option: "Hip",
      available: true,
    },
    {
      id: 4,
      option: "Ridge",
      available: true,
    },
    {
      id: 5,
      option: "Valley",
      available: true,
    },
    {
      id: 6,
      option: "Rake",
      available: true,
    },
    {
      id: 7,
      option: "Eave",
      available: true,
    },
    {
      id: 8,
      option: "Drip edge",
      available: false,
    },
    {
      id: 9,
      option: "Step Flashing",
      available: true,
    },
    {
      id: 10,
      option: "Head Flashing",
      available: false,
    },
    {
      id: 11,
      option: "Waste Calculation",
      available: false,
    },
  ],
};
